import { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { IRouteParam } from "../../pages/Bond";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

const useLimits = (LimitsUrl: string) => {
    const { ID_Anag, ID_FideAffidamento, ID_Polizza } = useParams<IRouteParam>();
    const { ShowDialog } = useContext(AlertDialogContext);

    const [ImportoGarantito, setImportoGarantito] = useState(0);
    const [RiduzioneSommaGarantita, setRiduzioneSommaGarantita] = useState<undefined | number>(undefined);
    const [DerogationLimits, setDerogationLimits] = useState<Dati.Dictionary<any>>({});

    useEffect(() => {
        GetLimits();
    }, [LimitsUrl]);

    useEffect(() => {
        GetDerogationLimits();
    }, []);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetLimits = (): void => {
        const Param: CChiamaWebParametri = {
            URL: LimitsUrl,
            OnRis: OnGetLimits,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetLimits = (sender: ChiamaWeb, data: Dati.CRisAPI_DatiLimitiBinder) => {
        if (!data.Errore) {
            setImportoGarantito(data.ImportoGarantito);
            setRiduzioneSommaGarantita(data.RiduzioneSommaGarantita);
        }
    };

    const GetDerogationLimits = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/deroga/GetLimitiDeroga?ID_Deroga=${ID_Polizza}&ID_TipoDerogaStato=${Glob.Tipi_DR_Approvata}`,
            OnRis: OnGetDerogationLimits,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetDerogationLimits = (sender: ChiamaWeb, data: Dati.CRisAPIDizionario<Dati.CTipoCampoDeroga>) => {
        if (!data.Errore) {
            const fields = data.Dati;
            const newDerogationLimits = { ...DerogationLimits };

            for (const field in fields) {
                const indicator = fields[field].Verso == ">" ? "MAX" : "MIN";

                switch (fields[field].Tipo) {
                    case "Importo":
                    case "Percentuale":
                        newDerogationLimits[field + indicator] = Number(fields[field].Valore);
                        break;
                    case "Data":
                        newDerogationLimits[field + indicator] = moment(fields[field].Valore).utc().format();
                        break;
                    case "Testo":
                        newDerogationLimits[field + indicator] = fields[field].Valore.toString();
                        break;
                }
            }

            setDerogationLimits(newDerogationLimits);
        }
    };

    const CalculateLimits = (CoAssicurazioneJSON: string, ProductBinderJSON: string): Dati.Dictionary<number> => {
        const limits: Dati.Dictionary<number> = {};
        let ImportoGarantitoMAXBinder = 0;
        let CoAss: Dati.CDatoCoAssicurazione[] = [];
        let BP: Dati.CDatoBinderProdottoCoAssicurazione[] = [];

        try {
            if (CoAssicurazioneJSON.length > 0) {
                CoAss = JSON.parse(CoAssicurazioneJSON);
            }
        } catch {
            CoAss = [];
        }

        try {
            BP = JSON.parse(ProductBinderJSON);
        } catch {
            BP = [];
        }

        limits["DirittiEmissioneMAX"] = 0;
        limits["DirittiEmissioneMIN"] = 0;
        limits["DirittiEmissioneNEUTRO"] = 0;

        limits["AccessoriMAX"] = 0;
        limits["AccessoriMIN"] = 0;
        limits["AccessoriNEUTRO"] = 0;

        limits["PremioNettoMAX"] = 0;
        limits["PremioNettoMIN"] = 0;
        limits["PremioNettoNEUTRO"] = 0;

        limits["TassoMAX"] = 100;
        limits["TassoMIN"] = 0;
        limits["TassoNEUTRO"] = 0;

        limits["ImportoGarantitoMIN"] = 0;
        limits["ImportoGarantitoNEUTRO"] = 0;

        for (let x: number = 0; x < CoAss?.length; x++) {
            for (let y: number = 0; y < BP?.length; y++) {
                if (BP[y].ID_AnagCompagnia == CoAss[x].ID_Anag) {
                    limits["DirittiEmissioneMAX"] = limits["DirittiEmissioneMAX"] + (BP[y].LimiteDirittiFissi * CoAss[x].Quota) / 100;
                    limits["AccessoriMAX"] = limits["AccessoriMAX"] + (BP[y].LimiteAccessori * CoAss[x].Quota) / 100;
                    if (CoAss[x].Delegataria) {
                        limits["PremioNettoMIN"] = BP[y].PremioMinimo;
                        limits["TassoMIN"] = BP[y].TassoMin;
                    }
                    ImportoGarantitoMAXBinder = ImportoGarantitoMAXBinder + (BP[y].LimitePerSingoloProdotto * CoAss[x].Quota) / 100;
                }
            }
        }

        limits["ImportoGarantitoMAX"] = ImportoGarantitoMAXBinder < ImportoGarantito ? ImportoGarantitoMAXBinder : ImportoGarantito;

        for (var I in DerogationLimits) {
            if (I.substr(I.length - 3, 3) == "MAX") {
                if (DerogationLimits[I] > limits[I]) {
                    limits[I] = DerogationLimits[I];
                }
            } else {
                if (DerogationLimits[I] < limits[I]) {
                    limits[I] = DerogationLimits[I];
                }
            }
        }

        limits["PremioNettoMAX"] = limits["PremioNettoMIN"] * 1000;

        return limits;
    };

    return { DerogationLimits, RiduzioneSommaGarantita, CalculateLimits };
};

export default useLimits;



// WEBPACK FOOTER //
// ./src/inar2/hooks/Bond/Limits.ts